// extracted by mini-css-extract-plugin
export var measureBox = "_80-0";